import axios from "axios";
import { getItem } from "./LocalStorageManager";
import jwt_decode from "jwt-decode";
import UrlBase from "../url/Urls";

const publicFetch = axios.create();

const privateFetch = axios.create({
  baseURL: UrlBase.base_url + process.env.REACT_APP_API_CONTEXT,
});

privateFetch.interceptors.request.use(
  async (config) => {
    //validate uri to send token
    const { origin } = new URL(config.baseURL + config.url);
    const allowedOrigins = [UrlBase.base_url];
    const authInfo = await getItem("authAdminInfo");
    const accessToken = authInfo?.accessToken || authInfo?.tokenInfo?.access_token;
    if (accessToken) {
      const decodeToken = jwt_decode(accessToken);
      const expiresAt = decodeToken.exp;
      let valid = new Date().getTime() / 1000 < expiresAt;
      if (allowedOrigins.includes(origin) && valid) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      }
    }
    return config;
  }
  // error=>{
  //   return Promise.reject(error);
  // }
);

/**
 * Axion private external- external parval endpoints
 */
const privateExternalFetch = axios.create({
  baseURL:
    UrlBase.parval_external_api_base_url +
    process.env.REACT_APP_PARVAL_EXTERNAL_API_CONTEXT,
});

/**
 * Axion private external- interceptors
 */
privateExternalFetch.interceptors.request.use(async (config) => {
  //validate uri to send token
  const { origin } = new URL(config.baseURL + config.url);
  const allowedOrigins = [UrlBase.parval_external_api_base_url];
  if (allowedOrigins.includes(origin)) {
    config.headers.Authorization =
      process.env.REACT_APP_PARVAL_EXTERNAL_AUTHORIZATION;
  }
  return config;
});

export { publicFetch, privateFetch, privateExternalFetch };
